import { deepEqual } from '@Utils/index'

class ExpState {
  /**
   * 元素是否处于曝光状态
   */
  #elExpState = false
  #el
  #observer = null

  constructor(el, options, vnode, instance) {
    this.#el = el
    this.#observer = null
    this.createObserver(options, vnode, instance)
  }

  createObserver(opts, vnode, instance) {
    if (this.#observer !== null) {
      this.destroyObserver()
    }
    let frozen = false
    const expHandler = () => {
      // 曝光规范：允许重复曝光，至少需要间隔500ms
      if (frozen) return
      frozen = true
      setTimeout(() => {
        frozen = false
      }, 500)

      opts.callback()
      if (!opts.repeat) {
        this.destroyObserver()
      }
    }
    this.#elExpState = false

    this.#observer = new IntersectionObserver(
      entries => {
        const curState = entries.some(e => e.isIntersecting)
        if (curState === this.#elExpState) return
        this.#elExpState = curState

        if (curState) expHandler()
      },
      {
        // 规范：露出 80% 触发曝光
        threshold: [0.8]
      }
    )

    instance.$nextTick(() => {
      this.#observer.observe(this.#el)
    })
  }

  destroyObserver() {
    this.#observer && this.#observer.disconnect()
    this.#observer = null
  }
}

export const ExpUtils = {
  beforeMount(el, opts, vnode, instance) {
    if (typeof window.IntersectionObserver === 'undefined') {
      console.warn('IntersectionObserver API is not available in your browser.')
    } else {
      const state = new ExpState(el, opts, vnode, instance)
      el.track_exp_state = state
    }
  },
  updated(el, opts, vnode, instance) {
    if (!el.track_exp_state) return
    if (deepEqual(opts.value, opts.oldValue)) return
    el.track_exp_state.createObserver(
      {
        callback: opts.callback,
        repeat: opts.repeat
      },
      vnode,
      instance
    )
  },
  unmounted(el) {
    if (!el.track_exp_state) return
    el.track_exp_state.destroyObserver()
  }
}
